import {
  createCommunityStarterKit,
  createEmojiExtension,
  createMentionExtension,
  type MentionExtensionOptions,
  SubmitShortcut,
} from '@shared/dream-components';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';

interface CommentExtensionsOptions {
  placeholder: string;
  onKeyboardSubmit: () => void;
  mention: MentionExtensionOptions;
}

export const extensions = ({ placeholder, onKeyboardSubmit, mention }: CommentExtensionsOptions) => [
  createCommunityStarterKit(),
  Placeholder.configure({ placeholder }),
  Underline,
  Link.configure({ openOnClick: false, linkOnPaste: true }),
  createEmojiExtension(),
  createMentionExtension(mention),
  // Must come after StarterKit so its Mod-Enter binding wins over HardBreak's.
  SubmitShortcut.configure({ onSubmit: onKeyboardSubmit }),
];
